import { ApiClient } from "../api.client";
import {
  GetPaymentDetailRequest,
  GetPaymentDetailResponse,
  GetPaymentsHistoryRequest,
  GetPaymentsHistoryResponse,
  ListPaymentsRequest,
  ListPaymentsResponse,
} from "./types";
import {
  GetSubscriptionPlansRequest,
  GetSubscriptionPlansResponse,
} from "./types/get-subscription-plans.types";

const PaymentsApi = {
  /**
   * Order-centric admin Payments list — the unified view replacing the old
   * separate Transactions + Payment Events tabs.
   */
  list(params: ListPaymentsRequest) {
    return ApiClient.get<ListPaymentsResponse>("/admin/payments/payments", {
      params,
    });
  },
  /** Full Order detail with linked Transaction + grouped attempt timelines. */
  getDetail({ orderId }: GetPaymentDetailRequest) {
    return ApiClient.get<GetPaymentDetailResponse>(
      `/admin/payments/payments/${orderId}`,
    );
  },
  // Legacy: kept for the per-user OrdersTab while it still exists. The new
  // PaymentsTab uses `list({ userId })` instead and replaces this.
  getPaymentsHistory(params: GetPaymentsHistoryRequest) {
    return ApiClient.get<GetPaymentsHistoryResponse>("/admin/payments/orders", {
      params,
    });
  },
  getSubscriptionPlans(params: GetSubscriptionPlansRequest) {
    return ApiClient.get<GetSubscriptionPlansResponse>(
      "/admin/payments/plans",
      {
        params,
      },
    );
  },
};

export { PaymentsApi };
export * from "./types";
